import type { Branch, Deal, ProagricaTypes } from "../../../api/types";

/**
 * Gets the lab account number for a grower, checking deal and branch sources.
 * Returns deal lab account number unless it contains "branch",
 * then uses branch-specific lab account number.
 */
export function getLabAccountNumber(
	deal: Deal,
	grower: ProagricaTypes.Grower,
	growerBranchMap: Record<string, Branch>,
): string | undefined {
	const labAccountNumber_Deal = deal.labAccountNumber;
	let labAccountNumber = labAccountNumber_Deal;
	if (labAccountNumber_Deal?.toLowerCase().includes("branch")) {
		const branch = growerBranchMap[grower.ID];
		if (branch) {
			const labAccountNumber_Branch = branch.labAccountNumber;
			if (labAccountNumber_Branch) {
				labAccountNumber = labAccountNumber_Branch;
			}
		}
	}
	return labAccountNumber;
}
